import React from 'react';
import { SeparatorCard, SeparatorInnerCard } from './CircularProgressBar.styled';

function Separator(props: { readonly turns: number }) {
    return (
        <SeparatorCard
            style={{
                transform: `rotate(${props.turns}turn)`,
            }}
        >
            <SeparatorInnerCard />
        </SeparatorCard>
    );
}

function RadialSeparators(props: { count: number }) {
    const turns = 1 / props.count;
    const separatorNumber = 0.5; // to center the separator
    const separatorTurns = Array.from({ length: props.count }, (_, index) => index * turns + separatorNumber);
    return separatorTurns.map((turn) => <Separator key={turn} turns={turn} />);
}

export default RadialSeparators;
